import { render, staticRenderFns } from "./CompetencySection.vue?vue&type=template&id=2f2b0de1&scoped=true&"
import script from "./CompetencySection.vue?vue&type=script&lang=js&"
export * from "./CompetencySection.vue?vue&type=script&lang=js&"
import style0 from "./CompetencySection.vue?vue&type=style&index=0&id=2f2b0de1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2b0de1",
  null
  
)

export default component.exports